const routes = [
    {
        path: "/ticket/event/type",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "ticketeventtype_index"
        }
    }
];

export default routes;
